import { useEffect, useRef, useState } from "react";
export const useMenuOpenHandler = ({ onToolbarMenuOpen, onToolbarMenuClose }) => {
    const menusRef = useRef({});
    const [anyMenusOpen, setAnyMenusOpen] = useState(false);
    const updateAnyMenusOpen = (key, isOpen) => {
        menusRef.current[key] = isOpen;
        setAnyMenusOpen(Object.values(menusRef.current).some((v) => v));
    };
    const handleOnToolbarMenuOpen = (key) => updateAnyMenusOpen(key, true);
    const handleOnToolbarMenuClose = (key) => updateAnyMenusOpen(key, false);
    useEffect(() => {
        if (Object.values(menusRef.current).length > 0) {
            if (anyMenusOpen) {
                onToolbarMenuOpen && onToolbarMenuOpen();
            }
            else {
                onToolbarMenuClose && onToolbarMenuClose();
            }
        }
    }, [anyMenusOpen, onToolbarMenuClose, onToolbarMenuOpen]);
    return { handleOnToolbarMenuOpen, handleOnToolbarMenuClose };
};
